export const isEmptyObject = (object: any) => {
  if (!object) return true
  return Object.keys(object).length === 0
}
